import {
	Injectable
} from '@angular/core';
import { Constantes } from '../../domain/constantes';

import {
	EntityManager,
	MetadataStore,
	EntityQuery,
	Predicate
} from 'breeze-client';

import {
	AuthenticationService
} from '../authentication/authentication.service';

// Import required breeze adapters. Rollup.js requires the use of breeze.base.debug.js, which doesn't include
// the breeze adapters.
import 'breeze-client/breeze.dataService.webApi';
import 'breeze-client/breeze.modelLibrary.backingStore';
import 'breeze-client/breeze.uriBuilder.json';
import 'breeze-client/breeze.uriBuilder.odata';
import { allSettled } from 'q';
import * as Q from 'q';
import { throwMatDialogContentAlreadyAttachedError } from '@angular/material';
import { environment } from '../../../environments/environment';

// The entityManager manages a static master manager and a per instance sandbox manager.
@ Injectable()
export class EntityManagerProvider {include
	redirectUrl: string;
	masterManager: EntityManager;
	ms: MetadataStore;
	BREEZE_endpoint = environment.urlServicioBreeze;
	IDIOMAS: any[] = null;
	FUNCIONALIDADES: any = {};

	constructor(private authService: AuthenticationService) {
		const that = this;

	this.authService.setHeaderToken();
		this.ms = new MetadataStore();

		// Configuramos El EntityManager de Breeze
		this.masterManager = this.getMasterManager();
		this.masterManager.saveOptions.allowConcurrentSaves = true;
		this.masterManager.metadataStore.fetchMetadata(this.BREEZE_endpoint);
	}

	//#region **** METODOS PRIVADOS ****

	/* METADATA */
	private getMasterManager(): EntityManager {
		// console.log('getMasterManager');
		const _masterManager	= new EntityManager({
			serviceName: this.BREEZE_endpoint,
			metadataStore: this.ms
		});
		return _masterManager;
	}

	/* GET */
	private getByCriteria(entidad, where?, expands?, columns?): any{
		// console.log('getByCriteria ' + entidad + " [" + parent.location.href + "]");

		const that = this;
		const query = EntityQuery.from(entidad).where(where).select(columns).expand(expands)
		.using(this.masterManager);
		return this.masterManager.executeQuery(query)
		.then( function(data) {
			// Renovamos el Token
			// that.authService.relogin();
			const Entidades = data.results;
			return Entidades;
		})
		.catch(function(e) {
			console.log('EXCEPTION getByCriteria ' + e);

			const codigo = e.status;
			if (codigo === 401){
				return that.authService.relogin()
				.then(function(token){
					that.authService.setHeaderToken();
					return that.getByCriteria(entidad, where, expands);
				});
			}
		});
	}

	private getByCriteriaOrder(entidad, where?, order?, top?, page?, expands?, columns?): any{
		console.log('getByCriteriaOrder');
		const that = this;
		const query = EntityQuery.from(entidad)
		.where(where)
		.select(columns)
		.expand(expands)
		.orderBy(order)
		.inlineCount()
		.skip((page * top))
		// .top(top * 2) // DCANETE BUG breeze, segun reordene, la consulta puede cambiar, debido a que el top lo replica en todas las subconsultas
		.top(top)
		.using(this.masterManager);

		return this.masterManager.executeQuery(query)

		.then( function(data) {
			// Renovamos el Token
			// that.authService.relogin();

			const Entidades = data.results;
			return {
				entidades: Entidades,
				total: data.inlineCount
			};
		})
		.catch(function(e) {
			console.log('EXCEPTION getByCriteria ' + e);

			const codigo = e.status;
			if (codigo === 401){
				return that.authService.relogin()
				.then(function(token){
					that.authService.setHeaderToken();
					return that.getByCriteria(entidad, where, expands);
				});
			}
		});
	}

	private getById(entidad, Id, expands?, columns?) {
		console.log('getById');
		const that = this;
		const query = EntityQuery.from(entidad).select(columns).where('Id', '==', Id).expand(expands)
		.using(this.masterManager);

		return this.masterManager.executeQuery(query)
		.then( function(data) {
			// Renovamos el Token
			// that.authService.relogin();

			const Entidades = data.results;
			return Entidades;
		})
		.catch(function(e){
			const codigo = e.status;
			if (codigo === 401){
				return that.authService.relogin()
				.then(function(token){
					that.authService.setHeaderToken();
					return that.getById(entidad, Id, expands);
				});
			}
		});
	}

	/* NEW */
	nuevaEntity(entity: string){
		return this.newEntity(entity);
	}

	private newEntity(entity: string): any{
	console.log('newEntity');

		const that = this;
		/*
		const query = EntityQuery.from(entity)
		.using(this.masterManager);

		return this.masterManager.executeQuery(query)
		.then( function(data) {
			// Renovamos el Token
			// that.authService.relogin();
		*/
			const promise = new Promise((resolve, reject) => {
				const entidad = that.masterManager.createEntity(entity);
				resolve(entidad);
			});

			return promise;
		/*
			const entidad = that.masterManager.createEntity(entity);
			return entidad;

		})
		.catch(function(e){
			const codigo = e.status;
			if (codigo === 401){
				return that.authService.relogin()
				.then(function(token){
					that.authService.setHeaderToken();
					return that.newEntity(entity);
				});
			}
		});
*/
	}

	//#endregion

	//#region **** METODOS GENERICOS ****

	/* SAVE */
	saveChanges(that?){
		// console.log('saveChanges');
		that = this !== undefined ? this : that;
		return that.masterManager.saveChanges()
		.then((a) => {
			console.log('OK: saveChanges ');
			return a;
		}).catch(function(e) {
			console.log('ERROR: saveChanges ');
			const codigo = e.status;
			if (codigo === 401) {
				return that.authService.relogin()
				.then(function(token) {
					that.authService.setHeaderToken();
					return that.saveChanges();
				});
			}
			else {
				that.masterManager.rejectChanges();
				throw e;
			}
		});
	}

	/* REJECT */
	RejectChanges(that?){
		that = this !== undefined ? this : that;
		that.masterManager.rejectChanges();
	}

	/* DELETE */
	deleteEntity(entidad: any, that?){
		that = this !== undefined ? this : that;
		if (entidad) {
			const TIPO = entidad.constructor.name.split('_UBIMAPS', 2)[0];
			try {

				if (entidad.FOTOS && entidad.FOTOS.length > 0) {
					that.deleteEntityArray(entidad.FOTOS);
				}

				if (entidad.FOTO && entidad.FOTO.length > 0) {
					that.deleteEntityArray(entidad.FOTO);
				}

				const retDelete = entidad.entityAspect.setDeleted();
				// console.log('OK: deleteEntity ' + TIPO + ': ' + entidad.Id);
				return retDelete;

			} catch (e) {
				console.log(e);
				console.log('ERROR: deleteEntity ' + TIPO + ': ' + entidad.Id);
			}
		}
	}

	deleteEntityArray(entityArray: any[], that?){
		that = this !== undefined ? this : that;
		if (entityArray) {
			for (let index = entityArray.length - 1; index >= 0; index--) {
				const element = entityArray[index];
				const TIPO = element.constructor.name.split('_', 2)[0];
				try {
					that.deleteEntity(element);
				} catch (e) {
					console.log('ERROR: deleteEntityArray ' + TIPO + 's');
					return false;
				}
			}
		}
		return true;
	}


	//#endregion

	//#region  **** DELETE ****

	/* SECCION */
	// Usada para borrar una seccion directamenta, los Nodos se reasignaran a la seccion por defecto
	public deleteSECCION(entidad: any){
		const that = this;
		const idAla = entidad.IdAla;
		let seccionDefecto: any;
		const seccionBorrar = entidad;
		const idEspacio = this.authService.getIdEspacio();
		const where = new Predicate('ALA.NIVEL.ESPACIO.Id', '==', idEspacio);
		const include = 'NODOS, IDIOMAS, CONTENIDOS, CIUDADANO_UBICADO_ESPACIOS';

		return this.getSECCION(where, include)
		.then(function (secciones) {
			secciones = secciones.filter( x => x.IdAla === idAla);
			secciones = secciones.filter( x => x.Nombre === 'Default');
			seccionDefecto = secciones[0];
			const nodos = seccionBorrar.NODOS;

			// Reasigno los nodos que estaban en esta seccion a la seccion por defecto
			for (let index = nodos.length - 1; index >= 0; index--) {
				const nodo = nodos[index];
				nodo.SECCION = seccionDefecto;
			}

			return that.saveChanges();
		})
		.then(function(){
			return that.deleteCascadaSECCION(entidad);
		})
		.then(function(){
			return true;
		});
	}
	private deleteCascadaSECCION(entidad: any){
		return this.deleteCascadaSECCIONES([entidad]);
	}
	private deleteCascadaSECCIONES(array: any[], that?){
		console.log('** deleteCascadaSECCIONES: ' + array.length);
		that = this !== undefined ? this : that;

		const funcs = [];
		array.forEach(entidad => {
			try {
				funcs.push([that.deleteEntityArray, entidad.TIPOLOGIAS, that]);
				funcs.push([that.deleteEntityArray, entidad.IDIOMAS, that]);
				funcs.push([that.deleteEntityArray, entidad.CONTENIDOS, that]);
				funcs.push([that.deleteEntityArray, entidad.CIUDADANO_UBICADO_ESPACIOS, that]);
				funcs.push([that.saveChanges, null, that]);
				funcs.push([that.deleteEntity, entidad, that]);
				funcs.push([that.saveChanges, null, that]);
			} catch (e) {
				console.log(e);
			}
		});

		let result = Q(true);
		funcs.forEach( (arr) =>
		{
			const func = arr[0];
			const args = arr[1];
			that = arr[2];
			result = result.then(() => {
				if (args) {
					return func(args, that);
				}
				else{
					return func(that);
				}
			});
		});
		return result;
	}
	// Borrado de las secciones desde otro borrado en cascada, ademas de ser un borrado profundo
	private loadAnddeleteCascadaSECCIONES(array: any[], that?){
		console.log('loadAnddeleteCascadaSECCIONES: ' + array.length);
		that = this !== undefined ? this : that;

		const funcs = [];
		array.forEach(entidad => {
			try {
				funcs.push([that.loadAnddeleteCascadaSECCION, entidad, that]);
			} catch (e) {
				console.log(e);
			}
		});

		let result = Q(true);
		funcs.forEach( (arr) =>
		{
			const func = arr[0];
			const args = arr[1];
			that = arr[2];
			result = result.then(() => {
				if (args) {
					return func(args, that);
				}
				else{
					return func(that);
				}
			});
		});
		return result;
	}
	private loadAnddeleteCascadaSECCION(entidad: any, that?){
		console.log('loadAnddeleteCascadaSECCION: ' + entidad.Id);
		that = this !== undefined ? this : that;
		const where = new Predicate('Id', '==', entidad.Id);
		const include = 'NODOS.CONTENIDOS, NODOS.IDIOMAS, NODOS.RUTA_has_NODOS, IDIOMAS, CONTENIDOS, CIUDADANO_UBICADO_ESPACIOS';

		return that.getSECCION(where, include)
		.then(function (secciones) {
			return that.fullDeleteCascadaSECCIONES(secciones, that);
		})
		.then(function(){
			return true;
		});
	}
	private fullDeleteCascadaSECCION(entidad: any, that){
		this.fullDeleteCascadaSECCIONES([entidad], that);
	}
	private fullDeleteCascadaSECCIONES(array: any[], that?){
		console.log('fullDeleteCascadaSECCIONES: ' + array.length);
		that = this !== undefined ? this : that;

		const funcs = [];
		array.forEach(entidad => {
			try {
				funcs.push([that.deleteCascadaNODOS, entidad.NODOS, that]);
				funcs.push([that.deleteEntityArray, entidad.IDIOMAS, that]);
				funcs.push([that.deleteEntityArray, entidad.CONTENIDOS, that]);
				funcs.push([that.deleteEntityArray, entidad.CIUDADANO_UBICADO_ESPACIOS, that]);

				funcs.push([that.saveChanges, null, that]);
				funcs.push([that.deleteEntity, entidad, that]);
				funcs.push([that.saveChanges, null, that]);
			} catch (e) {
				console.log(e);
			}
		});

		let result = Q(true);
		funcs.forEach( (arr) =>
		{
			const func = arr[0];
			const args = arr[1];
			that = arr[2];
			result = result.then(() => {
				if (args) {
					return func(args, that);
				}
				else{
					return func(that);
				}
			});
		});
		return result;
	}

	/* NODO */
	deleteNODO(entidad: any){
		return this.deleteCascadaNODO(entidad);
	}
	private deleteCascadaNODOS(array: any[], that?){
		console.log('** deleteCascadaNODOS: ' + array.length);
		that = this !== undefined ? this : that;
		const funcs = [];
		array.forEach(entidad => {
			try {
				funcs.push([that.deleteCascadaNODO, entidad, that]);
			} catch (e) {
				console.log(e);
			}
		});

		let result = Q(true);
		funcs.forEach( (arr) =>
		{
			const func = arr[0];
			const args = arr[1];
			that = arr[2];
			result = result.then(() => {
				if (args) {
					return func(args, that);
				}
				else{
					return func(that);
				}
			});
		});
		return result;

	}
	private deleteCascadaNODO(entidad: any, that?){
		that = this !== undefined ? this : that;
		const funcs = [];

		funcs.push([that.deleteRelacionesNodo, entidad, that]);
		funcs.push([that.loadAndDeleteCascadaCONEXIONES_NODOS, [entidad], that]);
		funcs.push([that.saveChanges, null, that]);
		funcs.push([that.deleteEntity, entidad, that]);
		funcs.push([that.saveChanges, null, that]);

		let result = Q(true);
		funcs.forEach( (arr) =>
		{
			const func = arr[0];
			const args = arr[1];
			that = arr[2];
			result = result.then(() => {
				if (args) {
					return func(args, that);
				}
				else{
					return func(that);
				}
			});
		});
		return result;
	}
	private deleteRelacionesNodo(nodo, that?){
		console.log('** deleteRelacionesNodo: ' + nodo.Id);
		that = this !== undefined ? this : that;

		const where = new Predicate('Id', '==', nodo.Id);
		const include = 'BALIZAS, CIUDADANO_UBICADO_ESPACIOS, IDIOMAS, RUTA_has_NODOS, CONTENIDOS';

		return that.getNODO(where, include)
		.then(function (nodos) {
			nodo = nodos[0];
			that.deleteEntityArray(nodo.BALIZAS, that);
			that.deleteEntityArray(nodo.CONTENIDOS, that);
			that.deleteEntityArray(nodo.CIUDADANO_UBICADO_ESPACIOS, that);
			that.deleteEntityArray(nodo.IDIOMAS, that);
			that.deleteEntityArray(nodo.RUTA_has_NODOS, that);
		})
		.then(function(){
			return true;
		});

	}

	/* CONEXIONS_NODO */
	// Borrado de las conexiones de una lista de nodos desde otro borrado en cascada, ademas de ser un borrado profundo
	private loadAndDeleteCascadaCONEXIONES_NODOS(arrayNODO: any[], that?){
		console.log('loadAndDeleteCascadaCONEXIONES_NODOS: ' + arrayNODO.length);
		that = this !== undefined ? this : that;

		const funcs = [];
		arrayNODO.forEach(entidad => {
			try {
				funcs.push([that.loadAndDeleteCascadaCONEXIONES_NODO, entidad, that]);
			} catch (e) {
				console.log(e);
			}
		});

		let result = Q(true);
		funcs.forEach( (arr) =>
		{
			const func = arr[0];
			const args = arr[1];
			that = arr[2];
			result = result.then(() => {
				if (args) {
					return func(args, that);
				}
				else{
					return func(that);
				}
			});
		});
		return result;
	}
	// Carga las conexiones del nodo pasado como parametro y las elimina
	private loadAndDeleteCascadaCONEXIONES_NODO(nodo: any, that?){
		console.log('loadAndDeleteCascadaCONEXIONES_NODO: ' + nodo.Id);
		that = this !== undefined ? this : that;
		const where = new Predicate('Id', '==', nodo.Id);
		let include = 'CONEXIONS_NODOS_ORIGEN.IDIOMAS, CONEXIONS_NODOS_DESTINO.IDIOMAS';
		include = include + ', CONEXIONS_NODOS_ORIGEN.PESO_CONEXIONS, CONEXIONS_NODOS_DESTINO.PESO_CONEXIONS';

		return that.getNODO(where, include)
		.then(function (nodos) {
			nodo = nodos[0];
			const conexiones = nodo.CONEXIONS_NODOS_ORIGEN.concat(nodo.CONEXIONS_NODOS_DESTINO);
			return that.deleteCascadaCONEXIONES_NODO(conexiones, that);
		})
		.then(function(){
			return true;
		});
	}
	deleteCascadaCONEXIONES_NODO(array: any[], that?){
		console.log('** deleteCascadaCONEXIONES_NODO: ' + array.length);
		that = this !== undefined ? this : that;
		const funcs = [];
		array.forEach(entidad => {
			try {
				funcs.push([that.deleteEntityArray, entidad.PESO_CONEXIONS, that]);
				funcs.push([that.deleteEntityArray, entidad.IDIOMAS, that]);
				funcs.push([that.saveChanges, null, that]);
				funcs.push([that.deleteEntity, entidad, that]);
				funcs.push([that.saveChanges, null, that]);
			} catch (e) {
				console.log(e);
			}
		});

		let result = Q(true);
		funcs.forEach( (arr) =>
		{
			const func = arr[0];
			const args = arr[1];
			that = arr[2];
			result = result.then(() => {
				if (args) {
					return func(args, that);
				}
				else{
					return func(that);
				}
			});
		});
		return result;
	}
	deleteCascadaCONEXION_NODO(entidad: any){
		return this.deleteCascadaCONEXIONES_NODO([entidad]);
	}

	/* NIVEL */
	deleteNIVEL(entidad: any, that?){
		that = this !== undefined ? this : that;
		return that.deleteCascadaNIVEL(entidad, that);
	}
	deleteNIVELES(array: any[], that?){
		that = this !== undefined ? this : that;
		return that.deleteCascadaNIVELES(array, that);
	}
	deleteCascadaNIVEL(entidad: any, that?){
		// that = this !== undefined ? this : that;
		// return that.deleteCascadaNIVELES([entidad], that);
		console.log('** deleteCascadaNIVEL: ' + entidad.Id);
		that = this !== undefined ? this : that;
		const where = new Predicate('Id', '==', entidad.Id);
		const include = 'ALAS, IDIOMAS, CONTENIDOS, TECNOLOGIAS';
		return that.getNIVEL(where, include)
		.then(function (entidades) {
			entidad = entidades[0];
			const funcs = [];
			funcs.push([that.loadAndDeleteCascadadeleteALAS, entidad.ALAS, that]);
			funcs.push([that.deleteEntityArray, entidad.TECNOLOGIAS, that]);
			funcs.push([that.deleteEntityArray, entidad.IDIOMAS, that]);
			funcs.push([that.deleteEntityArray, entidad.CONTENIDOS, that]);
			funcs.push([that.saveChanges, null, that]);
			funcs.push([that.deleteEntity, entidad, that]);
			funcs.push([that.saveChanges, null, that]);
			let result = Q(true);
			funcs.forEach( (arr) =>
			{
				const func = arr[0];
				const args = arr[1];
				that = arr[2];
				result = result.then(() => {
					if (args) {
						return func(args, that);
					}
					else{
						return func(that);
					}
				});
			});
			return result;
		});
	}
	deleteCascadaNIVELES(array: any[], that?){
		console.log('** deleteCascadaNIVELES: ' + array.length);
		that = this !== undefined ? this : that;
		const funcs = [];
		array.forEach(entidad => {
			try {
					funcs.push([that.deleteCascadaNIVEL, entidad, that]);
			} catch (e) {
				console.log(e);
			}
		});

		let result = Q(true);
		funcs.forEach( (arr) =>
		{
			const func = arr[0];
			const args = arr[1];
			that = arr[2];
			result = result.then(() => {
				if (args) {
					return func(args, that);
				}
				else{
					return func(that);
				}
			});
		});
		return result;
	}

	/* ALA */
	deleteGEOCALIBRACION_ALA(idAla, that?){
		console.log('** deleteGEOCALIBRACION_ALA.IdAla: ' + idAla);
		that = this !== undefined ? this : that;
		return that.getGEOCALIBRACION_ALAByIdAla(idAla)
		.then(function (geocalibracion_alas) {
			const geo = geocalibracion_alas[0];
			return that.deleteEntity(geo, that);
		})
		.then(function(){
			return that.saveChanges();
		})
		.then(function(){
			return true;
		});
	}

	deleteALA(entidad: any, that?){
		console.log('** deleteALA: ' + entidad.Id);
		that = this !== undefined ? this : that;
		const include = 'CONTENIDOS_SITUADOS_EN_ALA';
		return that.getALAById(entidad.Id, include)
		.then(function (alas) {
			const ala = alas[0];
			const CONTENIDOS_SITUADOS_EN_ALA = ala.CONTENIDOS_SITUADOS_EN_ALA;
			for (let index = CONTENIDOS_SITUADOS_EN_ALA.length - 1; index >= 0; index--) {
				const contenido = CONTENIDOS_SITUADOS_EN_ALA[index];
				contenido.ALA_PLANO = null;
				contenido.IdAlaPlano = null;
			}
			return that.saveChanges();
		})
		.then(function(){
			return that.deleteCascadaALA(entidad);
		})
		.then(function(){
			return true;
		});
	}

	private loadAndDeleteCascadadeleteALAS(array: any[], that?){
		that = this !== undefined ? this : that;

		const funcs = [];
		array.forEach(entidad => {
			try {
				funcs.push([that.deleteALA, entidad, that]);
			} catch (e) {
				console.log(e);
			}
		});

		let result = Q(true);
		funcs.forEach( (arr) =>
		{
			const func = arr[0];
			const args = arr[1];
			that = arr[2];
			result = result.then(() => {
				if (args) {
					return func(args, that);
				}
				else{
					return func(that);
				}
			});
		});
		return result;

	}
	private deleteCascadaALA(entidad: any, that?){
		console.log('** deleteCascadaALA: ' + entidad.Id);
		that = this !== undefined ? this : that;
		// return this.deleteCascadaALAS([entidad], that);

		const where = new Predicate('Id', '==', entidad.Id);
		const include = 'SECCIONS, CIUDADANO_UBICADO_ESPACIOS, IDIOMAS, CONTENIDOS';

		return that.getALA(where, include)
		.then(function (entidades) {
			entidad = entidades[0];
			const funcs = [];
			funcs.push([that.deleteGEOCALIBRACION_ALA, entidad.Id, that]);
			funcs.push([that.loadAnddeleteCascadaSECCIONES, entidad.SECCIONS, that]);
			funcs.push([that.deleteEntityArray, entidad.IDIOMAS, that]);
			funcs.push([that.deleteEntityArray, entidad.CONTENIDOS, that]);
			funcs.push([that.deleteEntityArray, entidad.CIUDADANO_UBICADO_ESPACIOS]);
			funcs.push([that.saveChanges, null, that]);
			funcs.push([that.deleteEntity, entidad, that]);
			funcs.push([that.saveChanges, null, that]);

			let result = Q(true);
			funcs.forEach( (arr) =>
			{
				const func = arr[0];
				const args = arr[1];
				that = arr[2];
				result = result.then(() => {
					if (args) {
						return func(args, that);
					}
					else{
						return func(that);
					}
				});
			});
			return result;
		})
		.then(function(){
			return true;
		});
	}
	private deleteCascadaALAS(array: any[], that?){
		console.log('** deleteCascadaALAS: ' + array.length);
		that = this !== undefined ? this : that;

		const funcs = [];
		array.forEach(entidad => {
			try {
				funcs.push([that.deleteCascadaALA, entidad, that]);
			} catch (e) {
				console.log(e);
			}
		});

		let result = Q(true);
		funcs.forEach( (arr) =>
		{
			const func = arr[0];
			const args = arr[1];
			that = arr[2];
			result = result.then(() => {
				if (args) {
					return func(args, that);
				}
				else{
					return func(that);
				}
			});
		});
		return result;
	}

	/* RUTA */
	deleteRUTAS(rutasArray: any[], that?){
		console.log('** deleteRUTAS: ' + rutasArray.length);
		that = this !== undefined ? this : that;
		return that.deleteCascadaRUTAS(rutasArray, that);
	}
	deleteRUTA(entidad: any, that?){
		console.log('** deleteRUTA: ' + entidad.Id);
		that = this !== undefined ? this : that;
		return that.deleteCascadaRUTA(entidad, that);
	}
	private deleteRelacionesRuta(ruta: any, that?){
		console.log('** deleteRelacionesRuta: ' + ruta.Id);
		that = this !== undefined ? this : that;

		const where = new Predicate('Id', '==', ruta.Id);
		const include = 'RUTA_has_NODOS, IDIOMAS, CIUDADANO_SOLICITUD_RUTA_SUGERIDAS, RUTA_has_CONTENIDOS';

		return that.getRUTA(where, include)
		.then(function (rutas) {
			ruta = rutas[0];
			that.deleteEntityArray( ruta.RUTA_has_CONTENIDOS, that);
			that.deleteEntityArray( ruta.RUTA_has_NODOS, that);
			that.deleteEntityArray( ruta.CIUDADANO_SOLICITUD_RUTA_SUGERIDAS, that);
			that.deleteEntityArray( ruta.IDIOMAS, that);
		})
		.then(function(){
			return true;
		});
	}
	private deleteCascadaRUTA(entidad: any, that?){
		that = this !== undefined ? this : that;
		const funcs = [];

		funcs.push([that.deleteRelacionesRuta, entidad, that]);
		funcs.push([that.saveChanges, null, that]);
		funcs.push([that.deleteEntity, entidad, that]);
		funcs.push([that.saveChanges, null, that]);

		let result = Q(true);
		funcs.forEach( (arr) =>
		{
			const func = arr[0];
			const args = arr[1];
			that = arr[2];
			result = result.then(() => {
				if (args) {
					return func(args, that);
				}
				else{
					return func(that);
				}
			});
		});
		return result;
	}
	private deleteCascadaRUTAS(array: any[], that?){
		console.log('** deleteCascadaRUTAS: ' + array.length);
		that = this !== undefined ? this : that;

		const funcs = [];
		array.forEach(entidad => {
			try {
				funcs.push([that.deleteCascadaRUTA, entidad, that]);
			} catch (e) {
				console.log(e);
			}
		});

		let result = Q(true);
		funcs.forEach( (arr) =>
		{
			const func = arr[0];
			const args = arr[1];
			that = arr[2];
			result = result.then(() => {
				if (args) {
					return func(args, that);
				}
				else{
					return func(that);
				}
			});
		});
		return result;
	}

	/* NOTICIA */
	deleteNOTICIA(entidad: any){
		this.deleteNOTICIAS([entidad]);
	}
	deleteNOTICIAS(array: any[]){
		const funcs = [];
		array.forEach(entidad => {
			try {
				funcs.push([this.deleteEntityArray, entidad.IDIOMAS, this]);
				funcs.push([this.saveChanges, null, this]);
				funcs.push([this.deleteEntity, entidad, this]);
				funcs.push([this.saveChanges, null, this]);
			} catch (e) {
				console.log(e);
			}
		});

		let result = Q(true);
		funcs.forEach( (arr) =>
		{
			const func = arr[0];
			const args = arr[1];
			const that = arr[2];
			result = result.then(() => {
				if (args) {
					return func(args, that);
				}
				else{
					return func(that);
				}
			});
		});
		return result;
	}
	/* TIPOLOGIA_SECCIONES */
	deleteTIPOLOGIA_SECCION(entidad: any, that?){
		console.log('** deleteTIPOLOGIA_SECCION: ' + entidad.Id);
		that = this !== undefined ? this : that;
		return that.deleteCascadaTIPOLOGIA_SECCION(entidad, that);
	}
	private deleteCascadaTIPOLOGIA_SECCION(entidad: any, that?){
		that = this !== undefined ? this : that;
		const funcs = [];
		funcs.push([that.deleteRelacionesTIPOLOGIA_SECCION, entidad, that]);
		funcs.push([that.deleteEntity, entidad, that]);
		funcs.push([that.saveChanges, null, that]);
		let result = Q(true);
		funcs.forEach( (arr) =>
		{
			const func = arr[0];
			const args = arr[1];
			that = arr[2];
			result = result.then(() => {
				if (args) {
					return func(args, that);
				}
				else{
					return func(that);
				}
			});
		});
		return result;
	}

	private deleteRelacionesTIPOLOGIA_SECCION(tipo: any, that?){
		console.log('** deleteRelacionesTIPOLOGIA_SECCION: ' + tipo.Id);
		that = this !== undefined ? this : that;
		const where = new Predicate('Id', '==', tipo.Id);
		const include = 'IDIOMAS, SECCIONES';
		return that.getTIPOLOGIA_SECCION(where, include)
		.then(function (tipos) {
			tipo = tipos[0];
			console.log(tipo)
			that.deleteEntityArray( tipo.IDIOMAS, that);
			that.deleteEntityArray( tipo.SECCIONES, that); // SECCIONES es la relacion SECCION_has_TIPOLOGIA
			return that.saveChanges(that);
		})
		.then(function(){
			return true;
		});
	}
	/* TIPOLOGIA_CONTENIDO */
	deleteTIPOLOGIAS_CONTENIDO(rutasArray: any[], that?){
		console.log('** deleteTIPOLOGIAS_CONTENIDO: ' + rutasArray.length);
		that = this !== undefined ? this : that;
		return that.deleteCascadaTIPOLOGIAS_CONTENIDO(rutasArray, that);
	}
	deleteTIPOLOGIA_CONTENIDO(entidad: any, that?){
		console.log('** deleteTIPOLOGIA_CONTENIDO: ' + entidad.Id);
		that = this !== undefined ? this : that;
		return that.deleteCascadaTIPOLOGIA_CONTENIDO(entidad, that);
	}
	private deleteCascadaTIPOLOGIA_CONTENIDO(entidad: any, that?){
		that = this !== undefined ? this : that;
		const funcs = [];
		funcs.push([that.deleteRelacionesTIPOLOGIA_CONTENIDO, entidad, that]);
		funcs.push([that.deleteEntity, entidad, that]);
		funcs.push([that.saveChanges, null, that]);
		let result = Q(true);
		funcs.forEach( (arr) =>
		{
			const func = arr[0];
			const args = arr[1];
			that = arr[2];
			result = result.then(() => {
				if (args) {
					return func(args, that);
				}
				else{
					return func(that);
				}
			});
		});
		return result;
	}
	private deleteCascadaTIPOLOGIAS_CONTENIDO(array: any[], that?){
		console.log('** deleteCascadaTIPOLOGIAS_CONTENIDO: ' + array.length);
		that = this !== undefined ? this : that;

		const funcs = [];
		array.forEach(entidad => {
			try {
				funcs.push([that.deleteCascadaTIPOLOGIA_CONTENIDO, entidad, that]);
			} catch (e) {
				console.log(e);
			}
		});

		let result = Q(true);
		funcs.forEach( (arr) =>
		{
			const func = arr[0];
			const args = arr[1];
			that = arr[2];
			result = result.then(() => {
				if (args) {
					return func(args, that);
				}
				else{
					return func(that);
				}
			});
		});
		return result;
	}
	private deleteRelacionesTIPOLOGIA_CONTENIDO(tipo: any, that?){
		console.log('** deleteRelacionesTIPOLOGIA_CONTENIDO: ' + tipo.Id);
		that = this !== undefined ? this : that;
		const where = new Predicate('Id', '==', tipo.Id);
		const include = 'IDIOMAS';
		return that.getTIPOLOGIA_CONTENIDO(where, include)
		.then(function (tipos) {
			tipo = tipos[0];
			that.deleteEntityArray( tipo.IDIOMAS, that);
			return that.saveChanges(that);
		})
		.then(function(){
			return true;
		});


	}

	/* CONTENIDO */
	deleteCONTENIDO(entidad: any, that?){
		console.log('** deleteCONTENIDO: ' + entidad.Id);
		that = this !== undefined ? this : that;
		return that.deleteCascadaCONTENIDO(entidad, that);
	}

	deleteCONTENIDOS_ESPACIO(espacio: any, that?){
		console.log('** deleteCONTENIDOS_ESPACIO: ' + espacio.Id);
		that = this !== undefined ? this : that;
		const where = new Predicate('EspacioPertenencia', '==', espacio.Id);
		return that.getCONTENIDO(where)
		.then(function (contenidos) {
			return that.deleteCascadaCONTENIDOS(contenidos, that);
		});
	}

	deleteCONTENIDOS(array: any[], that?){
		console.log('** deleteCONTENIDOS: ' + array.length);
		that = this !== undefined ? this : that;
		return that.deleteCascadaCONTENIDOS(array, that);
	}
	private deleteCascadaCONTENIDO(entidad: any, that?){
		that = this !== undefined ? this : that;

		const where = new Predicate('Id', '==', entidad.Id);
		const include = 'IDIOMAS, RUTAS, CONTENIDO_WEB_EXTERNAS.IDIOMAS, NIVELES, ESPACIOS, ALAS, SECCIONES, NODODS';
		return that.getCONTENIDO(where, include)
		.then(function (entidades) {
			entidad = entidades[0];

			if (entidad.RUTAS.length > 0 ) {
				return 'CON RUTAS';
			}

			const funcs = [];
			funcs.push([that.deleteRelacionesCONTENIDO, entidad, that]);
			funcs.push([that.deleteCONTENIDO_WEB_EXTERNAS, entidad.CONTENIDO_WEB_EXTERNAS, that]);
			funcs.push([that.deleteEntity, entidad, that]);
			funcs.push([that.saveChanges, null, that]);
			let result = Q(true);
			funcs.forEach( (arr) =>
			{
				const func = arr[0];
				const args = arr[1];
				that = arr[2];
				result = result.then(() => {
					if (args) {
						return func(args, that);
					}
					else{
						return func(that);
					}
				});
			});
			return result;
		})
		.then(function(resp){

			if(resp === 'CON RUTAS'){
				return false;
			}
			else{
				return true;
			}

		});
	}
	private deleteCascadaCONTENIDOS(array: any[], that?){
		console.log('** deleteCascadaCONTENIDOS: ' + array.length);
		that = this !== undefined ? this : that;
		const funcs = [];
		array.forEach(entidad => {
			try {
				funcs.push([that.deleteCascadaCONTENIDO, entidad, that]);
			} catch (e) {
				console.log(e);
			}
		});
		let result = Q(true);
		funcs.forEach( (arr) =>
		{
			const func = arr[0];
			const args = arr[1];
			that = arr[2];
			result = result.then(() => {
				if (args) {
					return func(args, that);
				}
				else{
					return func(that);
				}
			});
		});
		return result;
	}
	private deleteRelacionesCONTENIDO(contenido: any, that?){
		console.log('** deleteRelacionesCONTENIDO: ' + contenido.Id);
		that = this !== undefined ? this : that;
		that.deleteEntityArray(contenido.NIVELES, that);
		that.deleteEntityArray(contenido.ESPACIOS, that);
		that.deleteEntityArray(contenido.ALAS, that);
		that.deleteEntityArray(contenido.SECCIONES, that);
		that.deleteEntityArray(contenido.NODODS, that);
		that.deleteEntityArray(contenido.IDIOMAS, that);
		that.deleteEntityArray(contenido.FOTOS, that);
		that.deleteEntity(contenido.MODELO_3D, that);
		return that.saveChanges(that);
	}

	/* MODELO_3D */
	deleteMODELO_3D(entidad: any, that?){
		console.log('** deleteMODELO_3D: ' + entidad.Id);
		that = this !== undefined ? this : that;
		return that.deleteCascadaMODELO_3D(entidad, that);
	}

	private deleteCascadaMODELO_3D(entidad: any, that?){
		that = this !== undefined ? this : that;

		const where = new Predicate('Id', '==', entidad.Id);
		return that.getMODELO_3D(where)
		.then(function (entidades) {
			entidad = entidades[0];

			const funcs = [];
			funcs.push([that.deleteEntity, entidad, that]);
			funcs.push([that.saveChanges, null, that]);
			let result = Q(true);
			funcs.forEach( (arr) =>
			{
				const func = arr[0];
				const args = arr[1];
				that = arr[2];
				result = result.then(() => {
					if (args) {
						return func(args, that);
					}
					else{
						return func(that);
					}
				});
			});
			return result;
		})
		.then(function(resp){
			return true;
		});
	}

	/* CONTENIDO_WEB_EXTERNA */
	deleteCONTENIDO_WEB_EXTERNA(entidad: any, that?){
		that = this !== undefined ? this : that;
		const funcs = [];
		funcs.push([that.deleteEntityArray, entidad.IDIOMAS, that]);
		funcs.push([that.saveChanges, null, that]);
		funcs.push([that.deleteEntity, entidad, that]);
		funcs.push([that.saveChanges, null, that]);
		let result = Q(true);
		funcs.forEach( (arr) =>
		{
			const func = arr[0];
			const args = arr[1];
			that = arr[2];
			result = result.then(() => {
				if (args) {
					return func(args, that);
				}
				else{
					return func(that);
				}
			});
		});
		return result;
	}
	deleteCONTENIDO_WEB_EXTERNAS(websArray: any[], that?){
		console.log('** deleteCONTENIDO_WEB_EXTERNAS: ' + websArray.length);
		that = this !== undefined ? this : that;
		const funcs = [];
		websArray.forEach(entidad => {
			try {
				funcs.push([that.deleteCONTENIDO_WEB_EXTERNA, entidad, that]);
			} catch (e) {
				console.log(e);
			}
		});
		let result = Q(true);
		funcs.forEach( (arr) =>
		{
			const func = arr[0];
			const args = arr[1];
			that = arr[2];
			result = result.then(() => {
				if (args) {
					return func(args, that);
				}
				else{
					return func(that);
				}
			});
		});
		return result;
	}

	/* ESPACIO */
	// TODO: Cascada con FKs
	deleteESPACIO(espacio: any, that?){
		console.log('** deleteESPACIO: ' + espacio.Id);
		that = this !== undefined ? this : that;
		const where = new Predicate('Id', '==', espacio.Id);
		let include = 'NIVELS, NOTICIAS, RUTAS_SUGERIDA, FOTOS, TECNOLOGIAS';
		include = include + ', CIUDADANOS_UBICADO_ESPACIO, PERFIL_MOVILIDAD_CIUDADANOS';
		include = include + ', POSICION_ULTIMAS, USUARIOS.USUARIO, IDIOMAS, POSICION_ACTUALS';
		include = include + ', AVISO_CIUDADANO, TIPOLOGIA_CONTENIDOS, CONTENIDOS.CONTENIDO';

		return that.getESPACIO(where, include)
		.then(function (espacios) {
			espacio = espacios[0];

			that = this !== undefined ? this : that;
			const funcs = [];

			const usuariosEspacio = [];
			espacio.USUARIOS.forEach(element => {
				usuariosEspacio.push(element.USUARIO);
			});

			funcs.push([that.deleteNIVELES, espacio.NIVELS, that]);
			funcs.push([that.deleteNOTICIAS, espacio.NOTICIAS, that]);
			funcs.push([that.deleteEntityArray, espacio.USUARIOS, that]);
			funcs.push([that.deleteUSUARIOS, usuariosEspacio, that]);
			funcs.push([that.deleteRUTAS, espacio.RUTAS_SUGERIDA, that]);
			funcs.push([that.deleteEntityArray, espacio.AVISO_CIUDADANO, that]);
			funcs.push([that.deleteEntityArray, espacio.CIUDADANOS_UBICADO_ESPACIO, that]);
			funcs.push([that.deleteEntityArray, espacio.CONTENIDOS, that]);
			funcs.push([that.deleteCONTENIDOS_ESPACIO, espacio, that]);
			funcs.push([that.deleteEntityArray, espacio.TECNOLOGIAS, that]);
			funcs.push([that.deleteEntityArray, espacio.IDIOMAS, that]);
			funcs.push([that.deletePERFIL_MOVILIDAD_CIUDADANOS, espacio.PERFIL_MOVILIDAD_CIUDADANOS, that]);
			funcs.push([that.deleteTIPOLOGIAS_CONTENIDO, espacio.TIPOLOGIA_CONTENIDOS, that]);
			funcs.push([that.deleteEntityArray, espacio.POSICION_ACTUALS, that]);
			funcs.push([that.deleteEntityArray, espacio.POSICION_ULTIMAS, that]);
			funcs.push([that.deleteEntityArray, espacio.FOTOS, that]);
			funcs.push([that.saveChanges, that]);
			funcs.push([that.deleteEntity, espacio, that]);
			funcs.push([that.saveChanges, null, that]);
			let result = Q(true);
			funcs.forEach( (arr) =>
			{
				const func = arr[0];
				const args = arr[1];
				that = arr[2];
				result = result.then(() => {
					if (args) {
						return func(args, that);
					}
					else{
						return func(that);
					}
				});
			});
			return result;
		})
		.then(function(){
			return true;
		});
	}

	/* PERFIL_MOVILIDAD_CIUDADANO */
	deletePERFIL_MOVILIDAD_CIUDADANO(entidad: any, that?){
		console.log('** deletePERFIL_MOVILIDAD_CIUDADANO: ' + entidad.Id);
		that = this !== undefined ? this : that;
		return that.deletePERFIL_MOVILIDAD_CIUDADANO(entidad, that);
	}
	deletePERFIL_MOVILIDAD_CIUDADANOS(array: any[], that?){
		console.log('** deletePERFIL_MOVILIDAD_CIUDADANOS: ' + array.length);
		that = this !== undefined ? this : that;
		return that.deleteCascadaPERFIL_MOVILIDAD_CIUDADANOS(array, that);
	}

	private deleteCascadaPERFIL_MOVILIDAD_CIUDADANO(perfil, that?){
		console.log('** deleteCascadaPERFIL_MOVILIDAD_CIUDADANO: ' + perfil.Id);

		that = this !== undefined ? this : that;
		const where = new Predicate('Id', '==', perfil.Id);
		const include = 'PESO_CONEXIONS, IDIOMAS';

		return that.getPERFIL_MOVILIDAD_CIUDADANO(where, include)
		.then(function (perfiles) {
			perfil = perfiles[0];
			const funcs = [];
			funcs.push([that.deleteEntityArray, perfil.PESO_CONEXIONS, that]);
			funcs.push([that.deleteEntityArray, perfil.IDIOMAS, that]);
			funcs.push([that.saveChanges, that]);
			funcs.push([that.deleteEntity, perfil, that]);
			funcs.push([that.saveChanges, null, that]);
			let result = Q(true);
			funcs.forEach( (arr) =>
			{
				const func = arr[0];
				const args = arr[1];
				that = arr[2];
				result = result.then(() => {
					if (args) {
						return func(args, that);
					}
					else{
						return func(that);
					}
				});
			});
			return result;
		})
		.then(function(){
			return true;
		});
	}

	private deleteCascadaPERFIL_MOVILIDAD_CIUDADANOS(array, that?){
		console.log('** deleteCascadaPERFIL_MOVILIDAD_CIUDADANOS: ' + array.length);
		that = this !== undefined ? this : that;
		const funcs = [];
		array.forEach(entidad => {
			try {
				funcs.push([that.deleteCascadaPERFIL_MOVILIDAD_CIUDADANO, entidad, that]);
			} catch (e) {
				console.log(e);
			}
		});

		let result = Q(true);
		funcs.forEach( (arr) =>
		{
			const func = arr[0];
			const args = arr[1];
			that = arr[2];
			result = result.then(() => {
				if (args) {
					return func(args, that);
				}
				else{
					return func(that);
				}
			});
		});
		return result;
	}

	private deleteUSUARIOS(usuarios, that?){
		console.log('** deletePERFIL_MOVILIDAD_CIUDADANO: ' + usuarios.length);
		console.log('**** TODO:: ');
	}


	/* BALIZA */
	deleteBALIZA(entidad: any){
		return this.deleteCascadaBALIZA(entidad);
	}
	private deleteCascadaBALIZAS(array: any[], that?){
		console.log('** deleteCascadaBALIZAS: ' + array.length);
		that = this !== undefined ? this : that;
		const funcs = [];
		array.forEach(entidad => {
			try {
				funcs.push([that.deleteCascadaBALIZA, entidad, that]);
			} catch (e) {
				console.log(e);
			}
		});

		let result = Q(true);
		funcs.forEach( (arr) =>
		{
			const func = arr[0];
			const args = arr[1];
			that = arr[2];
			result = result.then(() => {
				if (args) {
					return func(args, that);
				}
				else{
					return func(that);
				}
			});
		});
		return result;

	}
	private deleteCascadaBALIZA(entidad: any, that?){
		that = this !== undefined ? this : that;
		const funcs = [];

		funcs.push([that.deleteRelacionesBaliza, entidad, that]);
		funcs.push([that.saveChanges, null, that]);
		funcs.push([that.deleteEntity, entidad, that]);
		funcs.push([that.saveChanges, null, that]);

		let result = Q(true);
		funcs.forEach( (arr) =>
		{
			const func = arr[0];
			const args = arr[1];
			that = arr[2];
			result = result.then(() => {
				if (args) {
					return func(args, that);
				}
				else{
					return func(that);
				}
			});
		});
		return result;
	}
	private deleteRelacionesBaliza(baliza, that?){
		console.log('** deleteRelacionesBaliza: ' + baliza.Id);
		that = this !== undefined ? this : that;

		const where = new Predicate('Id', '==', baliza.Id);
		const include = 'NODOS';

		return that.getBALIZA(where, include)
		.then(function (balizas) {
			baliza = balizas[0];
			that.deleteEntityArray(baliza.NODOS, that);
		})
		.then(function(){
			return true;
		});

	}

	/* AVISO_CIUDADANO */
	deleteAVISO(entidad: any){
		return this.deleteCascadaAVISO(entidad);
	}
	private deleteCascadaAVISOS(array: any[], that?){
		console.log('** deleteCascadaAVISOS: ' + array.length);
		that = this !== undefined ? this : that;
		const funcs = [];
		array.forEach(entidad => {
			try {
				funcs.push([that.deleteCascadaAVISO, entidad, that]);
			} catch (e) {
				console.log(e);
			}
		});

		let result = Q(true);
		funcs.forEach( (arr) =>
		{
			const func = arr[0];
			const args = arr[1];
			that = arr[2];
			result = result.then(() => {
				if (args) {
					return func(args, that);
				}
				else{
					return func(that);
				}
			});
		});
		return result;
	}
	private deleteCascadaAVISO(entidad: any, that?){
		that = this !== undefined ? this : that;
		const funcs = [];

		funcs.push([that.deleteRelacionesAviso, entidad, that]);
		funcs.push([that.saveChanges, null, that]);
		funcs.push([that.deleteEntity, entidad, that]);
		funcs.push([that.saveChanges, null, that]);

		let result = Q(true);
		funcs.forEach( (arr) =>
		{
			const func = arr[0];
			const args = arr[1];
			that = arr[2];
			result = result.then(() => {
				if (args) {
					return func(args, that);
				}
				else{
					return func(that);
				}
			});
		});
		return result;
	}
	private deleteRelacionesAviso(entidad, that?){
		console.log('** deleteRelacionesAviso: ' + entidad.Id);
		that = this !== undefined ? this : that;

		const where = new Predicate('Id', '==', entidad.Id);
		const include = 'FOTO,SECCIONES, ESPACIOS, NODOS';

		return that.getAVISO_CIUDADANO(where, include)
		.then(function (avisos) {
			// entidad = avisos[0];
			// that.deleteEntityArray(entidad.FOTO, that);

			that = this !== undefined ? this : that;
			const funcs = [];

			funcs.push([that.deleteEntityArray, entidad.FOTO, that]);
			funcs.push([that.deleteEntityArray, entidad.SECCIONES, that]);
			funcs.push([that.deleteEntityArray, entidad.ESPACIOS, that]);
			funcs.push([that.deleteEntityArray, entidad.NODOS, that]);
			funcs.push([that.saveChanges, null, that]);

			let result = Q(true);
			funcs.forEach( (arr) =>
			{
				const func = arr[0];
				const args = arr[1];
				that = arr[2];
				result = result.then(() => {
					if (args) {
						return func(args, that);
					}
					else{
						return func(that);
					}
				});
			});
			return result;
		})
		.then(function(){
			return true;
		});
	}

	//#endregion

	//#region **** NEW and GET ****

	/* XXXXXX_has_YYYYYY */
	newNIVEL_has_CONTENIDO(): any {
		return	this.newEntity('NIVEL_has_CONTENIDO');
	}
	newESPACIO_has_CONTENIDO(){
		return	this.newEntity('ESPACIO_has_CONTENIDO');
	}
	newESPACIO_has_USUARIO(){
		return	this.newEntity('ESPACIO_has_USUARIO');
	}
	newALA_has_CONTENIDO(){
		return	this.newEntity('ALA_has_CONTENIDO');
	}
	newSECCION_has_CONTENIDO(){
		return	this.newEntity('SECCION_has_CONTENIDO');
	}
	newSECCION_has_TIPOLOGIA(){
		console.log('llega1')
		return	this.newEntity('SECCION_has_TIPOLOGIA');
	}
	newRUTA_has_CONTENIDO(){
		return	this.newEntity('RUTA_has_CONTENIDO');
	}
	newNODO_has_CONTENIDO(){
		return	this.newEntity('NODO_has_CONTENIDO');
	}
	newNIVEL_has_TECNOLOGIA(){
		return this.newEntity('NIVEL_has_TECNOLOGIA');
	}
	newESPACIO_has_TECNOLOGIA(){
		return this.newEntity('ESPACIO_has_TECNOLOGIA');
	}
	newNODO_has_BALIZA(){
		return	this.newEntity('NODO_has_BALIZA');
	}
	/* NODO */
	getNODO(where?, expands?, columns?): any{
		const idEspacio = this.authService.getIdEspacio();
		if (!where) {
			where = new Predicate('SECCION.ALA.NIVEL.ESPACIO.Id', '==', idEspacio);
		}
		else{
			where = where.and('SECCION.ALA.NIVEL.ESPACIO.Id', '==', idEspacio);
		}
		return this.getByCriteria('NODO', where, expands, columns);
	}

	newNodo(): any {
		const promises: any[] = [];
		const that = this;
		let nodo;
		return	 this.newEntity('NODO')
		.then(function(resp){
			nodo = resp;
			// Crear las relaciones con cada idiomas para la nueva conexion
			return that.newNodo_IDIOMA(nodo)
			.then(function(IDIOMAS){
				nodo.IDIOMAS = IDIOMAS;
				return nodo;
			});
		});
	}

	newNodo_IDIOMA(NODO: any){
		const promises: any[] = [];
		const that = this;
		let idiomas;
		return this.getIDIOMA()
		.then(function(oIdiomas){
			idiomas = oIdiomas;
			idiomas.forEach(idioma => {
				promises.push(that.newEntity('NODO_IDIOMA'));
			});
			return allSettled(promises);
		})
		.then(function(oNODO_Idioma){
			oNODO_Idioma                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                            .forEach(item => {
				const idioma = idiomas.pop();
				const nodoIdiomaIdioma = item.value;
				nodoIdiomaIdioma.IDIOMA = idioma;
				nodoIdiomaIdioma.NODO = NODO;
				nodoIdiomaIdioma.IdNodo = NODO.Id;
				nodoIdiomaIdioma.IdIdioma = idioma.Id;
				NODO.IDIOMAS.push(nodoIdiomaIdioma);
			});
			return NODO.IDIOMAS;
		});
	}

	/* ALA */
	getALA(where?, expands?, columns?): any{
		const idEspacio = this.authService.getIdEspacio();
		if (!where) {
			where = new Predicate('NIVEL.ESPACIO.Id', '==', idEspacio);
		}
		else{
			where = where.and('NIVEL.ESPACIO.Id', '==', idEspacio);
		}
		return this.getByCriteria('ALA', where, expands, columns);
	}

	getALAById(id: String, expands?, columns?): any{
        if (id) {
            const where = new Predicate('Id', '==', id);
            return this.getByCriteria('ALA', where, expands, columns);
        }
        else {
            return this.getALA(undefined, expands, columns);
        }
    }

	getGEOCALIBRACION_ALAByIdAla(idAla){
		const where = new Predicate('IdAla', '==', idAla);
		return this.getByCriteria('GEOCALIBRACION_ALA', where, null, null);
	}

	newALA(): any{
		const that = this;
		let ala;
		return this.newEntity('ALA')
		.then(function(resp){
			ala = resp;
			// Crear las relaciones con cada idiomas para la nueva conexion
			return that.newALA_IDIOMA(ala)
			.then(function(IDIOMAS){
				ala.IDIOMAS = IDIOMAS;
				return ala;
			});
		});
	}

	newALA_IDIOMA(ALA: any){
		const promises: any[] = [];
		const that = this;
		let idiomas;
		return this.getIDIOMA()
		.then(function(oIdiomas){
			idiomas = oIdiomas;
			idiomas.forEach(idioma => {
				promises.push(that.newEntity('ALA_IDIOMA'));
			});
			return allSettled(promises);
		})
		.then(function(oALA_Idioma){
			oALA_Idioma.forEach(item => {
				const idioma = idiomas.pop();
				const alaIdiomaIdioma = item.value;
				alaIdiomaIdioma.IDIOMA = idioma;
				alaIdiomaIdioma.ALA = ALA;
				alaIdiomaIdioma.IdAla = ALA.Id;
				alaIdiomaIdioma.IdIdioma = idioma.Id;
				ALA.IDIOMAS.push(alaIdiomaIdioma);
			});
			return ALA.IDIOMAS;
		});
	}

	/* BALIZA */
	getBALIZA(where?, expands?, columns?): any{
		return this.getByCriteria('BALIZA', where, expands, columns);
	}

	getBalizasEspacio(){
		// http://10.8.0.37:8888/breeze/Ubimaps/BALIZA?$filter=(EspacioPertenencia%20eq%20guid%27dc479657-6711-ec11-80f5-00505621ec8d%27)
		const idEspacio = this.authService.getIdEspacio();
		const where = new Predicate('EspacioPertenencia', '==', idEspacio);
		return this.getByCriteria('BALIZA', where, undefined, undefined);
	}

	newBALIZA(): any{
		return	 this.newEntity('BALIZA');
	}

	/* SECCION */
	getSECCION(where?, expands?, columns?): any{
		const idEspacio = this.authService.getIdEspacio();
		if (!where) {
			where = new Predicate('ALA.NIVEL.ESPACIO.Id', '==', idEspacio);
		}
		else{
			where = where.and('ALA.NIVEL.ESPACIO.Id', '==', idEspacio);
		}
		return this.getByCriteria('SECCION', where, expands, columns);
	}

	newSECCION(): any{
		const promises: any[] = [];
		const that = this;
		let newSECCION;
		return	 this.newEntity('SECCION')
		.then(function(seccion){
			newSECCION = seccion;
			// newSECCION.IdAlternativo = newSECCION.Id;
			newSECCION.IdAlternativo = Math.floor(Date.now() / 1000);

			// Crear las relaciones con cada idiomas para la nueva conexion
			return that.newSECCION_IDIOMA(newSECCION);
		})
		.then(function(IDIOMAS){
			newSECCION.IDIOMAS = IDIOMAS;
			return newSECCION;
		});
	}

	newSECCION_IDIOMA(SECCION: any){
		const promises: any[] = [];
		const that = this;
		let idiomas;
		return this.getIDIOMA()
		.then(function(oIdiomas){
			idiomas = oIdiomas;
			idiomas.forEach(idioma => {
				promises.push(that.newEntity('SECCION_IDIOMA'));
			});
			return allSettled(promises);
		})
		.then(function(oSECCION_Idioma){
			oSECCION_Idioma.forEach(item => {
				const idioma = idiomas.pop();
				const seccionIdiomaIdioma = item.value;
				seccionIdiomaIdioma.IDIOMA = idioma;
				seccionIdiomaIdioma.SECCION = SECCION;
				seccionIdiomaIdioma.IdSeccion = SECCION.Id;
				seccionIdiomaIdioma.IdIdioma = idioma.Id;
				SECCION.IDIOMAS.push(seccionIdiomaIdioma);
			});
			return SECCION.IDIOMAS;
		});
	}

	/* NIVEL */
	getNIVEL(where?, expands?, columns?): any{
		const idEspacio = this.authService.getIdEspacio();
		if (!where) {
			where = new Predicate('ESPACIO.Id', '==', idEspacio);
		}
		else{
			where = where.and('ESPACIO.Id', '==', idEspacio);
		}
		return this.getByCriteria('NIVEL', where, expands, columns);
	}

	newNIVEL(): any{
		const that = this;
		let nivel;
		let tecnologiaPorDefecto;
		let NIVEL_hasTECNOLOGIA;

		return that.getTECNOLOGIA('BEACON')
		.then(function (tecnologiasENTIDAD: any[]) {
			tecnologiaPorDefecto = tecnologiasENTIDAD[0];
			return that.newNIVEL_has_TECNOLOGIA();
		})
		.then(function (nivel_has_tecnologia: any[]) {
			NIVEL_hasTECNOLOGIA = nivel_has_tecnologia;
			NIVEL_hasTECNOLOGIA.TECNOLOGIA = tecnologiaPorDefecto;
			return that.newEntity('NIVEL');
		})
		.then(function(resp){
			nivel = resp;
			nivel.TECNOLOGIAS.push(NIVEL_hasTECNOLOGIA);
			// Crear las relaciones con cada idiomas para la nueva conexion
			return that.newNIVEL_IDIOMA(nivel)
			.then(function(IDIOMAS){
				nivel.IDIOMAS = IDIOMAS;
				return nivel;
			});
		});
	}

	newNIVEL_IDIOMA(NIVEL: any){
		const promises: any[] = [];
		const that = this;
		let idiomas;
		return this.getIDIOMA()
		.then(function(oIdiomas){
			idiomas = oIdiomas;
			idiomas.forEach(idioma => {
				promises.push(that.newEntity('NIVEL_IDIOMA'));
			});
			return allSettled(promises);
		})
		.then(function(oNIVEL_Idioma){
			oNIVEL_Idioma.forEach(item => {
				const idioma = idiomas.pop();
				const nivelIdiomaIdioma = item.value;
				nivelIdiomaIdioma.IDIOMA = idioma;
				nivelIdiomaIdioma.NIVEL = NIVEL;
				nivelIdiomaIdioma.IdNivel = NIVEL.Id;
				nivelIdiomaIdioma.IdIdioma = idioma.Id;
				NIVEL.IDIOMAS.push(nivelIdiomaIdioma);
			});
			return NIVEL.IDIOMAS;
		});
	}

	/* APP */
	getAPP(where?, expands?, columns?): any{
		return this.getByCriteria('APP', where, expands, columns);
	}

	newAPP(): any{
		return	 this.newEntity('APP');
	}

	/* CONTENIDO */
	getCONTENIDO(where?, expands?, columns?): any{
		const idEspacio = this.authService.getIdEspacio();
		if (where === undefined) {
			where = new Predicate('EspacioPertenencia', '==', idEspacio);
		}
		else{
			where = where.and('EspacioPertenencia', '==', idEspacio);
		}
		return this.getByCriteria('CONTENIDO', where, expands, columns);
	}

	getCONTENIDOOrdenado(where?, order?, top?, page?, expands?, columns?): any{
		if (!top){
			top = 10;
		}
		if (!page){
			page = 0;
		}
		return this.getByCriteriaOrder('CONTENIDO', where, order, top, page, expands, columns);
	}

	getContenidosById(ids, expands?, columns?){
		let where = new Predicate('Id', '==', ids[0]);
		ids.forEach(id => {
			where = where.or('Id', '==', id);
		});

		return this.getByCriteria('CONTENIDO', where, expands, columns);
	}

	getAVISOOrdenado(where?, order?, top?, page?, expands?): any{
		if (!top){
			top = 10;
		}
		if (!page){
			page = 0;
		}
		return this.getByCriteriaOrder('AVISO_CIUDADANO', where, order, top, page, expands);
	}

	newCONTENIDO(): any{
		const promises: any[] = [];
		const that = this;
		let CONTENIDO;
		return	 this.newEntity('CONTENIDO')
		.then(function(contenido){
			CONTENIDO = contenido;
			// Crear las relaciones con cada idiomas para la nueva conexion
			return that.newCONTENIDO_IDIOMA(CONTENIDO)
			.then(function(IDIOMAS){
				CONTENIDO.IDIOMAS = IDIOMAS;
				return CONTENIDO;
			});
		});
	}

	newCONTENIDO_IDIOMA(CONTENIDO: any){
		const promises: any[] = [];
		const that = this;
		let idiomas;
		return this.getIDIOMA()
		.then(function(oIdiomas){
			idiomas = oIdiomas;
			idiomas.forEach(idioma => {
				promises.push(that.newEntity('CONTENIDO_IDIOMA'));
			});
			return allSettled(promises);
		})
		.then(function(oCONTENIDO_Idioma){
			oCONTENIDO_Idioma.forEach(item => {
				const idioma = idiomas.pop();
				const contenidoIdiomaIdioma = item.value;
				contenidoIdiomaIdioma.IDIOMA = idioma;
				contenidoIdiomaIdioma.CONTENIDOS = CONTENIDO;
				contenidoIdiomaIdioma.IdContenido = CONTENIDO.Id;
				contenidoIdiomaIdioma.IdIdioma = idioma.Id;
				CONTENIDO.IDIOMAS.push(contenidoIdiomaIdioma);
			});
			return CONTENIDO.IDIOMAS;
		});
	}

	/* ESPACIO */
	getESPACIO(where?, expands?, columns?): any{
		return this.getByCriteria('ESPACIO', where, expands, columns);
	}

	newESPACIO(): any{
		const that = this;
		let espacio;
		let idUsuario;
		let idEntidad;
		let tecnologiaPorDefecto;
		let ESPACIO_has_TECNOLOGIA;
		let TIPOLOGIA_CONTENIDO;
		return this.newEntity('ESPACIO')
		.then(function(resp){
			espacio = resp;
			idEntidad = that.authService.getIdEntidad();
			espacio.IdEntidad = idEntidad;
			// Cambiar en el futuro para que sea seleccionable
			espacio.ColorSeleccionEspacio = 'rgba(184,219,184,0.6)';
			espacio.ColorFuenteEspacio = 'rgba(255,255,255,1)';
			espacio.ColorEspacio = 'rgba(100,102,101,1)';
			return that.newESPACIO_IDIOMA(espacio);
		})
		.then(function(IDIOMAS){
			espacio.IDIOMAS = IDIOMAS;
			return that.newESPACIO_has_USUARIO();
		})
		.then(function(newESPACIO_has_USUARIO){
			idUsuario = that.authService.getIdUsuario();
			newESPACIO_has_USUARIO.IdEspacio = espacio.Id;
			newESPACIO_has_USUARIO.IdUsuario = idUsuario;
			return that.getTECNOLOGIA('BEACON');
		})
		.then(function (tecnologiasENTIDAD: any[]) {
			tecnologiaPorDefecto = tecnologiasENTIDAD[0];
			return that.newESPACIO_has_TECNOLOGIA();
		})
		.then(function (espacio_has_tecnologia: any[]) {
			ESPACIO_has_TECNOLOGIA = espacio_has_tecnologia;
			ESPACIO_has_TECNOLOGIA.TECNOLOGIA = tecnologiaPorDefecto;
			espacio.TECNOLOGIAS.push(ESPACIO_has_TECNOLOGIA);

			return that.newTIPOLOGIA_CONTENIDO();
		})
		.then(function (tipologia_contenido: any[]) {
			TIPOLOGIA_CONTENIDO = tipologia_contenido;
			TIPOLOGIA_CONTENIDO.Tipo = 'CIUDADANO';
			TIPOLOGIA_CONTENIDO.Nombre = 'Visita';
			TIPOLOGIA_CONTENIDO.VisibilidadListaContenidosWeb = false;
			TIPOLOGIA_CONTENIDO.IconoRepresentacion = 'assets/itsoft/IconosSVG/SVG/tipologia-usuarios.svg';
			TIPOLOGIA_CONTENIDO.VisibleSoloEn = Constantes.VISIBLE_SI_UBICADO_EN.SIEMPRE;
			espacio.TIPOLOGIA_CONTENIDOS.push(TIPOLOGIA_CONTENIDO);

			return that.saveChanges();
		})
		.then(function (resp: any) {
			console.log(resp);
			return that.newPERFIL_MOVILIDAD_CIUDADANO();
		})
		.then(function (oPerfil: any) {

			oPerfil.IdEspacio = espacio.Id;
			oPerfil.Nomobre = 'Standar';
			oPerfil.IDIOMAS.forEach(PERFIL_MOVILIDAD_IDIOMA => {
				PERFIL_MOVILIDAD_IDIOMA.Nombre = 'Standar';
			});

			oPerfil.PesoMAximo = Constantes.PESO_DEFAULT; // that.perfilSeleccionado.PesoMAximo;

			return that.saveChanges();
		})
		.then(function(resp:any){
			console.log(resp);
			return espacio;
		});
	}


	newESPACIO_IDIOMA(ESPACIO: any){
		const promises: any[] = [];
		const that = this;
		let idiomas;
		return this.getIDIOMA()
		.then(function(oIdiomas){
			idiomas = oIdiomas;
			idiomas.forEach(idioma => {
				promises.push(that.newEntity('ESPACIO_IDIOMA'));
			});
			return allSettled(promises);
		})
		.then(function(oESPACIO_Idioma){
			oESPACIO_Idioma.forEach(item => {
				const idioma = idiomas.pop();
				const espacioIdiomaIdioma = item.value;
				espacioIdiomaIdioma.IdEspacio = ESPACIO.Id;
				espacioIdiomaIdioma.IdIdioma = idioma.Id;
				ESPACIO.IDIOMAS.push(espacioIdiomaIdioma);
			});
			return ESPACIO.IDIOMAS;
		});
	}

	/* NOTICIA */
	getNOTICIA(where?, expands?, columns?): any{
		return this.getByCriteria('NOTICIA', where, expands, columns);
	}

	newNOTICIA(): any{
		const that = this;
		let noticia;
		return this.newEntity('NOTICIA')
		.then(function(resp){
			noticia = resp;
			// Crear las relaciones con cada idiomas para la nueva conexion
			return that.newALA_IDIOMA(noticia)
			.then(function(IDIOMAS){
				noticia.IDIOMAS = IDIOMAS;
				return noticia;
			});
		});
	}

	newNOTICIA_IDIOMA(NOTICIA: any){
		const promises: any[] = [];
		const that = this;
		let idiomas;
		return this.getIDIOMA()
		.then(function(oIdiomas){
			idiomas = oIdiomas;
			idiomas.forEach(idioma => {
				promises.push(that.newEntity('NOTICIA_IDIOMA'));
			});
			return allSettled(promises);
		})
		.then(function(oNOTICIA_IDIOMA){
			oNOTICIA_IDIOMA.forEach(item => {
				const idioma = idiomas.pop();
				const alaIdiomaIdioma = item.value;
				alaIdiomaIdioma.IDIOMA = idioma;
				alaIdiomaIdioma.ALA = NOTICIA;
				alaIdiomaIdioma.IdAla = NOTICIA.Id;
				alaIdiomaIdioma.IdIdioma = idioma.Id;
				NOTICIA.IDIOMAS.push(alaIdiomaIdioma);
			});
			return NOTICIA.IDIOMAS;
		});
	}


	getNoticiaById(idNoticia, includes?, columns?){
		const that = this;
		const p1 = new Predicate('Id', '==', idNoticia);
		const query = EntityQuery.from('NOTICIA').select(columns).where(p1).using(this.masterManager).expand(includes);
		return this.masterManager.executeQuery(query)
		.then( function(data) {
			// Renovamos el Token
			// that.authService.relogin();
			if (data.results.length > 0) {
				return new Promise((resolve, reject) => {
					resolve(data.results);
				});
			}
		});
	}

	/* ENTIDAD */
	getENTIDAD(where?, expands?, columns?): any{
		return this.getByCriteria('ENTIDAD', where, expands, columns);
	}

	newENTIDAD(): any{
		return	 this.newEntity('ENTIDAD');
	}

	/* PERFIL */
	getPERFIL(where?, expands?, columns?): any{
		return this.getByCriteria('PERFIL', where, expands, columns);
	}

	newPERFIL(): any{
		return	 this.newEntity('PERFIL');
	}


	/* RUTA_SUGERIDA */
	getRUTA(where?, expands?, columns?): any{
		return this.getByCriteria('RUTA_SUGERIDA', where, expands, columns);
	}

	newRUTA_SUGERIDA(): any{
		const that = this;
		let ruta;
		return this.newEntity('RUTA_SUGERIDA')
		.then(function(resp){
			ruta = resp;
			return that.newRUTA_SUGERIDA_IDIOMA(ruta);
		})
		.then(function(IDIOMAS){
			ruta.IDIOMAS = IDIOMAS;
			return ruta;
		});
	}

	newRUTA_SUGERIDA_IDIOMA(RUTA_SUGERIDA: any){
		const promises: any[] = [];
		const that = this;
		let idiomas;
		return this.getIDIOMA()
		.then(function(oIdiomas){
			idiomas = oIdiomas;
			idiomas.forEach(idioma => {
				promises.push(that.newEntity('RUTA_SUGERIDA_IDIOMA'));
			});
			return allSettled(promises);
		})
		.then(function(oRUTA_SUGERIDA_IDIOMA){
			oRUTA_SUGERIDA_IDIOMA.forEach(item => {
				const idioma = idiomas.pop();
				const rutaIdiomaIdioma = item.value;
				rutaIdiomaIdioma.IDIOMA = idioma;
				rutaIdiomaIdioma.RUTA_SUGERIDA = RUTA_SUGERIDA;
				rutaIdiomaIdioma.IdRutaSugerida = RUTA_SUGERIDA.Id;
				rutaIdiomaIdioma.IdIdioma = idioma.Id;
				RUTA_SUGERIDA.IDIOMAS.push(rutaIdiomaIdioma);
			});
			return RUTA_SUGERIDA.IDIOMAS;
		});
	}

	/* TIPOLOGIA_NODO */
	getTIPOLOGIA_NODO(where?, expands?, columns?): any{
		return this.getByCriteria('TIPOLOGIA_NODO', where, expands, columns);
	}

	newTIPOLOGIA_NODO(): any{
		return	 this.newEntity('TIPOLOGIA_NODO');
	}

	/* TIPOLOGIA_CONTENIDO */
	getTIPOLOGIA_CONTENIDO(where?, expands?, columns?): any{
		return this.getByCriteria('TIPOLOGIA_CONTENIDO', where, expands, columns);
	}



	newTIPOLOGIA_CONTENIDO(): any{
		const promises: any[] = [];
		const that = this;
		let newTipologia;
		return	 this.newEntity('TIPOLOGIA_CONTENIDO')
		.then(function(tipologia){
			newTipologia = tipologia;
			return that.newTIPOLOGIA_CONTENIDO_IDIOMA(newTipologia);
		})
		.then(function(IDIOMAS){
			newTipologia.IDIOMAS = IDIOMAS;
			return newTipologia;
		});
	}

	newTIPOLOGIA_CONTENIDO_IDIOMA(TIPOLOGIA_CONTENIDO){
		const promises: any[] = [];
		const that = this;
		let idiomas;
		return this.getIDIOMA()
		.then(function(oIdiomas){
			idiomas = oIdiomas;
			idiomas.forEach(idioma => {
				promises.push(that.newEntity('TIPOLOGIA_CONTENIDO_IDIOMA'));
			});
			return allSettled(promises);
		})
		.then(function(oTIPOLOGIA_CONTENIDO_Idioma){
			oTIPOLOGIA_CONTENIDO_Idioma.forEach(item => {
				const idioma = idiomas.pop();
				const tipologiaContenidoIdiomaIdioma = item.value;
				tipologiaContenidoIdiomaIdioma.IDIOMA = idioma;
				tipologiaContenidoIdiomaIdioma.TIPOLOGIA_CONTENIDO = TIPOLOGIA_CONTENIDO;
				tipologiaContenidoIdiomaIdioma.IdTipologiaContenido = TIPOLOGIA_CONTENIDO.Id;
				tipologiaContenidoIdiomaIdioma.IdIdioma = idioma.Id;
				TIPOLOGIA_CONTENIDO.IDIOMAS.push(tipologiaContenidoIdiomaIdioma);
			});
			return TIPOLOGIA_CONTENIDO.IDIOMAS;
		});
	}

	/* TIPOLOGIA_SECCION */
	getTIPOLOGIA_SECCION(where?, expands?, columns?): any{
		console.log(where, expands)
		return this.getByCriteria('TIPOLOGIA_SECCION', where, expands, columns);
	}

		/* TIPOLOGIA_SECCION */
		getRelacionTIPOLOGIA_SECCION(where?, expands?, columns?): any{
			console.log(where, expands)
			return this.getByCriteria('SECCION_has_TIPOLOGIA', where, expands, columns);
		}

	newTIPOLOGIA_SECCION(): any{
		const promises: any[] = [];
		const that = this;
		let newTipologiaSeccion;
		return	 this.newEntity('TIPOLOGIA_SECCION')
		.then(function(tipologiaSeccion){
			newTipologiaSeccion = tipologiaSeccion;
			return that.newTIPOLOGIA_SECCION_IDIOMA(newTipologiaSeccion);
		})
		.then(function(IDIOMAS){
			newTipologiaSeccion.IDIOMAS = IDIOMAS;
			return newTipologiaSeccion;
		});
	}

	newTIPOLOGIA_SECCION_IDIOMA(TIPOLOGIA_SECCION){
		const promises: any[] = [];
		const that = this;
		let idiomas;
		return this.getIDIOMA()
		.then(function(oIdiomas){
			idiomas = oIdiomas;
			idiomas.forEach(idioma => {
				promises.push(that.newEntity('TIPOLOGIA_SECCION_IDIOMA'));
			});
			return allSettled(promises);
		})
		.then(function(oTIPOLOGIA_SECCION_Idioma){
			oTIPOLOGIA_SECCION_Idioma.forEach(item => {
				const idioma = idiomas.pop();
				const tipologiaSeccionIdioma = item.value;
				tipologiaSeccionIdioma.IDIOMA = idioma;
				tipologiaSeccionIdioma.TIPOLOGIA_SECCION = TIPOLOGIA_SECCION;
				tipologiaSeccionIdioma.idTipologiaSeccion = TIPOLOGIA_SECCION.Id;
				tipologiaSeccionIdioma.IdIdioma = idioma.Id;
				TIPOLOGIA_SECCION.IDIOMAS.push(tipologiaSeccionIdioma);
			});
			return TIPOLOGIA_SECCION.IDIOMAS;
		});
	}

	/* TIPOLOGIA_BALIZA */
	getTIPOLOGIA_BALIZA (where?, expands?, columns?): any{
		return this.getByCriteria('TIPOLOGIA_BALIZA', where, expands, columns);
	}


	/* USUARIO */
	getUSUARIO(where?, expands?, columns?): any{
		return this.getByCriteria('USUARIO', where, expands, columns);
	}

	newUSUARIO(): any{
		return	 this.newEntity('USUARIO');
	}

	/* AVISO_CIUDADANO */
	getAVISO_CIUDADANO(where?, expands?, columns?): any{
		return this.getByCriteria('AVISO_CIUDADANO', where, expands, columns);
	}

	newAVISO_CIUDADANO(): any{
		return this.newEntity('AVISO_CIUDADANO');
	}

	/* ESPACIO_has_AVISO */
	newESPACIO_has_AVISO(): any{
		return	this.newEntity('ESPACIO_has_AVISO');
	}

	/* SECCION_has_AVISO */
	newSECCION_has_AVISO(): any{
		return	 this.newEntity('SECCION_has_AVISO');
	}

	/* NODO_has_AVISO */
	newNODO_has_AVISO(): any{
		return	 this.newEntity('NODO_has_AVISO');
	}


	/* NODO_CALIBRACION_ALA */
	getNODO_CALIBRACION_ALA(where?, expands?, columns?): any{
		return this.getByCriteria('NODO_CALIBRACION_ALA', where, expands, columns);
	}

	newNODO_CALIBRACION_ALA(): any{
		return	 this.newEntity('NODO_CALIBRACION_ALA');
	}

	/* FOTO */
	newFOTO(){
		return	 this.newEntity('FOTO')
		.then(function(foto){
			return foto;
		});
	}

	/* CONEXION_NODOS */
	getCONEXION_NODOS(where?, expands?, columns?): any{
		return this.getByCriteria('CONEXION_NODOS', where, expands, columns);
	}

	newCONEXION_NODOS(): any{
		const promises: any[] = [];
		const that = this;
		let newConexion;
		return	 this.newEntity('CONEXION_NODOS')
		.then(function(Conexion){
			newConexion = Conexion;
			return that.newCONEXION_NODOS_IDIOMA(newConexion);
		})
		.then(function(IDIOMAS){
			newConexion.IDIOMAS = IDIOMAS;
			return newConexion;
		});
	}

	newCONEXION_NODOS_IDIOMA(CONEXION_NODO){
		const promises: any[] = [];
		const that = this;
		let idiomas;
		return this.getIDIOMA()
		.then(function(oIdiomas){
			idiomas = oIdiomas;
			idiomas.forEach(idioma => {
				promises.push(that.newEntity('CONEXION_NODO_IDIOMA'));
			});
			return allSettled(promises);
		})
		.then(function(oCONEXION_NODO_IDIOMA){
			oCONEXION_NODO_IDIOMA.forEach(item => {
				const idioma = idiomas.pop();
				const conexionIdiomaIdioma = item.value;
				conexionIdiomaIdioma.IDIOMA = idioma;
				conexionIdiomaIdioma.TIPOLOGIA_CONTENIDO = CONEXION_NODO;
				conexionIdiomaIdioma.IdTipologiaContenido = CONEXION_NODO.Id;
				conexionIdiomaIdioma.IdIdioma = idioma.Id;
				CONEXION_NODO.IDIOMAS.push(conexionIdiomaIdioma);
			});
			return CONEXION_NODO.IDIOMAS;
		});
	}
	/* PESO_CONEXION */
	getPESO_CONEXION(where?, expands?, columns?): any{
		return this.getByCriteria('PESO_CONEXION', where, expands, columns);
	}

	newPESO_CONEXION(): any{
		return	 this.newEntity('PESO_CONEXION');
	}

	/* PERFIL_MOVILIDAD_CIUDADANO */
	getPERFIL_MOVILIDAD_CIUDADANO(where?, expands?, columns?): any{
		return this.getByCriteria('PERFIL_MOVILIDAD_CIUDADANO', where, expands, columns);
	}

	newPERFIL_MOVILIDAD_CIUDADANO(): any{
		const that = this;
		let perfilMovilidad;
		return this.newEntity('PERFIL_MOVILIDAD_CIUDADANO')
		.then(function(PERFIL_MOVILIDAD_CIUDADANO){
			perfilMovilidad = PERFIL_MOVILIDAD_CIUDADANO;
			return that.newPERFIL_MOVILIDAD_CIUDADANO_IDIOMA(perfilMovilidad);
		})
		.then(function(IDIOMAS){
			perfilMovilidad.IDIOMAS = IDIOMAS;
			return perfilMovilidad;
		});
	}

	newPERFIL_MOVILIDAD_CIUDADANO_IDIOMA(PERFIL_MOVILIDAD_CIUDADANO){
		const promises: any[] = [];
		const that = this;
		let idiomas;
		return this.getIDIOMA()
		.then(function(oIdiomas){
			idiomas = oIdiomas;
			idiomas.forEach(idioma => {
				promises.push(that.newEntity('PERFIL_MOVILIDAD_CIUDADANO_IDIOMA'));
			});
			return allSettled(promises);
		})
		.then(function(oPERFIL_MOVILIDAD_CIUDADANO_IDIOMA){
			oPERFIL_MOVILIDAD_CIUDADANO_IDIOMA.forEach(item => {
				const idioma = idiomas.pop();
				const perfilMovilidadIdiomaIdioma = item.value;
				perfilMovilidadIdiomaIdioma.IDIOMA = idioma;
				perfilMovilidadIdiomaIdioma.PERFIL_MOVILIDAD_CIUDADANO = PERFIL_MOVILIDAD_CIUDADANO;
				perfilMovilidadIdiomaIdioma.IdPerfilMovilidad = PERFIL_MOVILIDAD_CIUDADANO.Id;
				perfilMovilidadIdiomaIdioma.IdIdioma = idioma.Id;
				PERFIL_MOVILIDAD_CIUDADANO.IDIOMAS.push(perfilMovilidadIdiomaIdioma);
			});
			return PERFIL_MOVILIDAD_CIUDADANO.IDIOMAS;
		});
	}

	/* CONTENIDO_WEB_EXTERNA */
	getCONTENIDO_WEB_EXTERNA(where?, expands?, columns?): any{
		return this.getByCriteria('CONTENIDO_WEB_EXTERNA', where, expands, columns);
	}

	newCONTENIDO_WEB_EXTERNA(): any{
		const promises: any[] = [];
		const that = this;
		let newContenidoWebExterna;
		return this.newEntity('CONTENIDO_WEB_EXTERNA')
		.then(function(PERFIL_MOVILIDAD_CIUDADANO){
			newContenidoWebExterna = PERFIL_MOVILIDAD_CIUDADANO;
			return that.newCONTENIDO_WEB_EXTERNA_IDIOMA(newContenidoWebExterna);
		})
		.then(function(IDIOMAS){
			newContenidoWebExterna.IDIOMAS = IDIOMAS;
			return newContenidoWebExterna;
		});
	}


	newCONTENIDO_WEB_EXTERNA_IDIOMA(CONTENIDO_WEB_EXTERNA){
		const promises: any[] = [];
		const that = this;
		let idiomas;
		return this.getIDIOMA()
		.then(function(oIdiomas){
			idiomas = oIdiomas;
			idiomas.forEach(idioma => {
				promises.push(that.newEntity('CONTENIDO_WEB_EXTERNA_IDIOMA'));
			});
			return allSettled(promises);
		})
		.then(function(oCONTENIDO_WEB_EXTERNA_IDIOMA){
			oCONTENIDO_WEB_EXTERNA_IDIOMA.forEach(item => {
				const idioma = idiomas.pop();
				const webexternaIdiomaIdioma = item.value;
				webexternaIdiomaIdioma.IDIOMA = idioma;
				webexternaIdiomaIdioma.CONTENIDO_WEB_EXTERNA = CONTENIDO_WEB_EXTERNA;
				webexternaIdiomaIdioma.IdContenido = CONTENIDO_WEB_EXTERNA.Id;
				webexternaIdiomaIdioma.IdIdioma = idioma.Id;
				CONTENIDO_WEB_EXTERNA.IDIOMAS.push(webexternaIdiomaIdioma);
			});
			return CONTENIDO_WEB_EXTERNA.IDIOMAS;
		});
	}

	/* IDIOMA */
	getIDIOMA(where?, expands?, columns?): any{
		//const predicado = new Predicate('IDIOMA.ENTIDAD.Visible', '==', true);
		const aux = this.getLocalIDIOMA();
		if (aux && aux.length > 0) {
			return Promise.resolve(aux);
		}

		return this.getByCriteria('IDIOMA', where, expands, columns)
		.then((idiomas) => {
			this.setLocalIDIOMA(idiomas);
			console.log('IDIOMAS CARGADOS');
			return Promise.resolve(idiomas);
		});
	}

	/* TECNOLOGIA */
	getTECNOLOGIA(Codigo: string): any{
		const predicado = new Predicate('Codigo', '==', Codigo);
		return this.getByCriteria('TECNOLOGIA', predicado, undefined, undefined);
	}
	//TODO: Probar a recuperar de local Storage para ahorrar peticiones

	public getLocalIDIOMA() {
		if (this.IDIOMAS) {
			console.log('IDIOMAS CARGADOS de MEMORIA');
		}
		return this.IDIOMAS;
	}

	public setLocalIDIOMA(idiomas) {
		this.IDIOMAS = idiomas;
	}
	// getFUNCIONALIDADESbyUSUARIO
	public getLocalFUNCIONALIDADES(idUsuario) {
		if ( this.FUNCIONALIDADES[idUsuario]) {
			console.log('PERMISOS CARGADOS de MEMORIA');
		}
		return this.FUNCIONALIDADES[idUsuario];
	}

	public setLocalFUNCIONALIDADES(func, idUsuario) {
		this.FUNCIONALIDADES[idUsuario] = func;
	}

	/* MODELO_3D */
	getMODELO_3D(where?, expands?, columns?): any{
		return this.getByCriteria('MODELO_3D', where, expands, columns);
	}

	newMODELO_3D(): any{
		return	 this.newEntity('MODELO_3D');
	}

	//#endregion

	//#region **** ESPECIALES ****

	/* CONTENIDO */
	getCONTENIDObyIdEspacio(idEspacio, includes?, columns?){
		const that = this;

		const predicado = new Predicate('ESPACIOS.Id', '==', idEspacio)
								.or('NODODS.SECCION.ALA.NIVEL.ESPACIO.Id', '==', idEspacio)
								.or('SECCIONES.ALA.NIVEL.ESPACIO.Id', '==', idEspacio)
								.or('NIVELES.ESPACIO.Id', '==', idEspacio)
								.or('ALAS.NIVEL.ESPACIO.Id', '==', idEspacio);

		return this.getCONTENIDO(predicado, includes, columns)
		.then(function(contenidos){
			return contenidos;
		});

	}

	public getContenidoById(Id, expands?, columns?): any{
		return this.getById('CONTENIDO', Id, expands, columns);
	}

/*
	public getContenidosByTipologiaId(ids, expands?, columns?){

		let  where = new Predicate('TIPOLOGIA_CONTENIDO.Id', '==', ids[0]);
		ids.forEach(id => {
			where = where.or('TIPOLOGIA_CONTENIDO.Id', '==', id);
		});

		const includes = 'TIPOLOGIA_CONTENIDO';

		return this.getCONTENIDO(where, includes);
		// return this.getByCriteria('CONTENIDO', where, expands, columns);
	}
*/
	getContenidosByTipologiaId(ids, expands?, columns?){
		let where = new Predicate('IdTipologia', '==', ids[0]);
		ids.forEach(id => {
			where = where.or('IdTipologia', '==', id);
		});

		return this.getByCriteria('CONTENIDO', where, expands, columns);
	}
	getTipologiasEspacio(idEspacio){
		const that = this;

		const predicado = new Predicate('IdEspacio', '==', idEspacio);
		return this.getTIPOLOGIA_CONTENIDO(predicado, 'IDIOMAS.IDIOMA')
		.then(function (entidades) {
            let tipologiasContenido = [];
			tipologiasContenido = entidades;
            tipologiasContenido.sort((a, b) => (a.Nombre > b.Nombre) ? 1 : ((b.Nombre > a.Nombre) ? -1 : 0));

            return tipologiasContenido;
		});
	}

	getTipologiasLocalizablesEspacio(idEspacio){
		const that = this;

		const predicado1 = new Predicate('IdEspacio', '==', idEspacio)
		.and('TipoUbicacion', '==', Constantes.TIPO_LOCALIZACION_ACTIVOS.DIRECTA)

		const predicado2 = new Predicate('IdEspacio', '==', idEspacio)
		.and('TipoUbicacion', '==', Constantes.TIPO_LOCALIZACION_ACTIVOS.INDIRECTA)

		const predicado = predicado1.or(predicado2)

		return this.getTIPOLOGIA_CONTENIDO(predicado, 'IDIOMAS.IDIOMA')
		.then(function (entidades) {
            let tipologiasContenido = [];
			tipologiasContenido = entidades;
            tipologiasContenido.sort((a, b) => (a.Nombre > b.Nombre) ? 1 : ((b.Nombre > a.Nombre) ? -1 : 0));

            return tipologiasContenido;
		});
	}

	/* ESPACIO */
	public getEspacioById(idEspacio, includes?, columns?){
		const that = this;
		const p1 = new Predicate('Id', '==', idEspacio);

		const query = EntityQuery.from('ESPACIO').select(columns).where(p1).using(this.masterManager).expand(includes);
		return this.masterManager.executeQuery(query)
		.then( function(data) {
			// Renovamos el Token
			// that.authService.relogin();

			if (data.results.length > 0) {

				return new Promise((resolve, reject) => {
						resolve(data.results[0]);
				});

			}

		});
	}

	getEspacioConNoticiasById(idEspacio, columns?){
		const that = this;
		const predicado = new Predicate('Id', '==', idEspacio);

		// const predicado = new Predicate('Id', '==', idEspacio);
		// predicado.and('NOTICIAS.IDIOMA.Default', '==', true);

		const query = EntityQuery.from('ESPACIO').select(columns).where(predicado).using(this.masterManager).expand('NOTICIAS.FOTOS');
		return this.masterManager.executeQuery(query)
		.then( function(data) {
			// Renovamos el Token
			//that.authService.relogin();

			if (data.results.length > 0) {

				return new Promise((resolve, reject) => {
						resolve(data.results[0]);
				});

			}

		});
	}

	/* RUTA_SUGERIDA */
	public getRutaById(idRuta, includes?, columns?){
		const that = this;
		const p1 = new Predicate('Id', '==', idRuta);

		const query = EntityQuery.from('RUTA_SUGERIDA').select(columns).where(p1).using(this.masterManager).expand(includes);
		return this.masterManager.executeQuery(query)
		.then( function(data) {
			// Renovamos el Token
			//that.authService.relogin();

			if (data.results.length > 0) {

				return new Promise((resolve, reject) => {
						resolve(data.results[0]);
				});

			}

		})
		.catch(function(err){
			console.log('getRutaById: ' + err);
		});
	}

	/* ENTIDAD */
	public getEntidadById(idEntidad, includes?, columns?): any{
		const that = this;
		const p1 = new Predicate('Id', '==', idEntidad);

		const query = EntityQuery.from('ENTIDAD').select(columns).where(p1).using(this.masterManager).expand(includes);
		return this.masterManager.executeQuery(query)
		.then( function(data) {
			// Renovamos el Token
			//that.authService.relogin();
			if (data.results.length > 0) {

				return new Promise((resolve, reject) => {
						resolve(data.results[0]);
				});

			}

		})
		.catch(function(e){
			return e;
		});
	}


	/* CONTENIDO_WEB_EXTERNA */
	public getCONTENIDO_WEB_EXTERNAbyCONTENIDO(Id, expands?, columns?){
		const that = this;
		const query = EntityQuery.from('CONTENIDO_WEB_EXTERNA').select(columns).where('IdContenido', '==', Id).expand(expands)
		.using(this.masterManager);

		return this.masterManager.executeQuery(query)
		.then( function(data) {
			// Renovamos el Token
			// that.authService.relogin();

			const Entidades = data.results;
			return Entidades;
		})
		.catch(function(e){
			const codigo = e.status;
			if (codigo === 401){
				return that.authService.relogin()
				.then(function(token){
					that.authService.setHeaderToken();
					return that.getById('CONTENIDO_WEB_EXTERNA', Id, expands);
				});
			}
		});
	}

	/* CONEXION_NODOS */
	getTramosCortados(IdEspacio, expands?, columns?){
		return "*** Deprecated ***"
		/*
		const that = this;
		IdEspacio = this.authService.getIdEspacio();
		let predicado = new Predicate('CortadoTemporalmente', '==', true);
		predicado = predicado.and('NodoOrigen.SECCION.ALA.NIVEL.IdEspacio', '==', IdEspacio);

		const query = EntityQuery.from('CONEXION_NODOS').select(columns).where(predicado).expand(expands)
		.using(this.masterManager);

		return this.masterManager.executeQuery(query)
		.then( function(data) {


			const Entidades = data.results;
			return Entidades;
		})
		.catch(function(e){
			const codigo = e.status;
			if (codigo === 401){
				return that.authService.relogin()
				.then(function(token){
					that.authService.setHeaderToken();
					return that.getById('CONTENIDO_WEB_EXTERNA', IdEspacio, expands);
				});
			}
		});
		*/
	}

	/* FUNCIONALIDADES Y PERFILES */
	public getFUNCIONALIDADESbyUSUARIO(idUsuario: string, columns?){

		const aux = this.getLocalFUNCIONALIDADES(idUsuario);
		if (aux) {
			return Promise.resolve(aux);
		}


		const expand = 'PERFIL.FUNCIONALIDADES.FUNCIONALIDAD, PERFIL.PERMISOS';
		const that = this;
		const IdEspacio = this.authService.getIdEspacio();
		const predicado = new Predicate('Id', '==', idUsuario);

		const query = EntityQuery.from('USUARIO').select(columns).where(predicado).expand(expand)
		.using(this.masterManager);

		return this.masterManager.executeQuery(query)
		.then( function(data) {
			// Renovamos el Token
			// that.authService.relogin();

			const Entidades: any = data.results[0];
			const funcionalidades = Entidades.PERFIL.FUNCIONALIDADES;
			that.setLocalFUNCIONALIDADES(funcionalidades, idUsuario)
			console.log('PERMISOS CARGADOS');
			return funcionalidades;
		})
		.catch(function(e){
			const codigo = e.status;
			if (codigo === 401){
				return that.authService.relogin()
				.then(function(token){
					that.authService.setHeaderToken();
				});
			}
		});

	}

	public getUSUARIObyIdEspacio(idEspacio: string, includes?, where?: Predicate){
		const that = this;

		const newWhere = new Predicate(where).and(new Predicate ('ESPACIOS', 'any', 'IdEspacio', '==', idEspacio));

		return this.getUSUARIO(newWhere, includes)
		.then(function(usuarios){
			const usuariosEspacio = [];
			usuarios.forEach(usu => {
				usu.ESPACIOS.forEach(esp => {
					if (esp.IdEspacio === idEspacio) {
						usuariosEspacio.push(usu);
					}
				});
			});
			return usuariosEspacio;
		});
	}

	/* REPARACION XXXXXX_IDIOMA */
	public repareESPACIO_IDIOMA(espacio: any ){

	}
	//#endregion

}



// WEBPACK FOOTER //
// C:/Users/adri9/Escritorio/admin-everpath/src/app/providers/entity-manager-provider/entity-manager-provider.ts